import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Modal } from "react-bootstrap";

import DatePicker from "react-datepicker";
import Icon from '@mui/material/Icon';
import { green, red } from '@mui/material/colors';
import ImageIcon from "../../../assets/images/Swipex_Upload_icon.png";
import ImageIconDull from "../../../assets/images/Swipex_Upload_icon_dull.png";

import { SUBMIT_REQUEST } from "../../AppConstant";

function Create({ setParentLoading, switchToStatusTab, userDetails }) {
    const isEmpty = (value) =>
        value === undefined ||
        value === "undefined" ||
        value === "UNDEFINED" ||
        value === null ||
        value === "" ||
        value === "null";

    const missingFields = [];

    if (isEmpty(userDetails.EmpName)) {
        missingFields.push("Location");
    }

    if (isEmpty(userDetails.EmpEmail)) {
        missingFields.push("Location");
    }

    if (isEmpty(userDetails.Location)) {
        missingFields.push("Location");
    }

    if (isEmpty(userDetails.Department)) {
        missingFields.push("Department");
    }

    if (isEmpty(userDetails.ReportingManagerName)) {
        missingFields.push("Reporting Manager Name");
    }

    if (isEmpty(userDetails.ReportingManagerEmail)) {
        missingFields.push("Reporting Manager Email");
    }

    const [location, setLocation] = useState("");
    const [department, setDepartment] = useState("");

    const [errorMessage, setErrorMessage] = useState("");

    const [startDate, setStartDate] = useState("");
    const [implementDate, setImplementDate] = useState("");

    const today = new Date();
    const minDate = new Date();
    minDate.setFullYear(today.getFullYear() - 1);
    const maxDate = new Date();
    maxDate.setFullYear(today.getFullYear() + 1);

    // IMPROVEMENT CATEGORY 
    const [improvementCategory, setImprovementCategory] = useState({
        productivity: false,
        quality: false,
        cost: false,
        delivery: false,
        safety: false,
        morale: false
    })

    const handleImprovementCategoryCheckboxChange = (e) => {
        const { id, checked } = e.target;

        setImprovementCategory((prev) => ({
            ...prev,
            [id]: checked,
        }));
    }

    // BENEFITS 
    const [benefits, setBenefits] = useState({
        productivity: "",
        quality: "",
        cost: "",
        delivery: "",
        safety: "",
        morale: ""
    })

    // PROBLEM DEFINITION & ACTIONS :
    const [titleProblemDefinition, setTitleProblemDefinition] = useState("");
    const [whatProblemDefinition, setWhatProblemDefinition] = useState("");
    const [whyProblemDefinition, setWhyProblemDefinition] = useState("");
    const [whenProblemDefinition, setWhenProblemDefinition] = useState("");
    const [howManyProblemDefinition, setHowManyProblemDefinition] = useState("");
    const [whatactionscount, setWhatActionsCount] = useState(1);

    const [whatActions, setWhatActions] = useState({
        what1: "",
        what2: "",
        what3: "",
    })
    const [whenActions, setWhenActions] = useState({
        when1: "",
        when2: "",
        when3: ""
    });
    const [whoActions, setWhoActions] = useState({
        who1: "",
        who2: "",
        who3: ""
    });
    const [howActions, setHowActions] = useState({
        how1: "",
        how2: "",
        how3: ""
    });

    const deleteWhatActions2 = () => {
        setWhatActionsCount(1);
        setWhatActions((prev) => ({
            ...prev,
            what2: "",
            what3: ""
        }));
        setWhenActions((prev) => ({
            ...prev,
            when2: "",
            when3: ""
        }));
        setWhoActions((prev) => ({
            ...prev,
            who2: "",
            who3: ""
        }));
        setHowActions((prev) => ({
            ...prev,
            how2: "",
            how3: ""
        }));
    }
    const deleteWhatActions3 = () => {
        setWhatActionsCount(2);
        setWhatActions((prev) => ({
            ...prev,
            what3: ""
        }));
        setWhenActions((prev) => ({
            ...prev,
            when3: ""
        }));
        setWhoActions((prev) => ({
            ...prev,
            who3: ""
        }));
        setHowActions((prev) => ({
            ...prev,
            how3: ""
        }));
    }

    // IMAGES
    const editImageRef = useRef(null);
    const problemImageRef = useRef(null);
    const beforeImageRef = useRef(null);
    const afterImageRef = useRef(null);
    const [editingIndex, setEditingIndex] = useState(null);

    const [problemImages, setProblemImages] = useState([]);
    const [problemImagesPreview, setProblemImagesPreview] = useState([]);
    const [problemImagesError, setProblemImagesError] = useState("");

    const [beforeImage, setBeforeImage] = useState(null);
    const [beforeImagePreview, setBeforeImagePreview] = useState(ImageIcon);
    const [beforeImageError, setBeforeImageError] = useState("");

    const [afterImage, setAfterImage] = useState(null);
    const [afterImagePreview, setAfterImagePreview] = useState(ImageIcon);
    const [afterImageError, setAfterImageError] = useState("");

    const [imagesDescription, setImagesDescription] = useState({
        ProblemImageDescription: "",
        BeforeImageDescription: "",
        AfterImageDescription: ""
    })

    const handleProblemImagesChange = (e) => {
        const files = Array.from(e.target.files);

        if (!files.length) return;

        const allowedTypes = [
            "image/jpeg",
            "image/png",
            "image/jpg",
            "image/jfif"
        ];

        const invalidFile = files.find(file => !allowedTypes.includes(file.type));

        if (invalidFile) {
            setProblemImagesError("Only JPG, JPEG, PNG, JFIF files are allowed");
            e.target.value = "";
            return;
        }

        const availableSlots = 3 - problemImages.length;

        if (files.length > availableSlots) {
            setProblemImagesError(`You can upload only ${availableSlots} more image(s).`);
            e.target.value = "";
            return;
        }

        const updatedImages = [...problemImages, ...files];

        const totalSize = updatedImages.reduce((sum, file) => sum + file.size, 0);

        if (totalSize > 10 * 1024 * 1024) {
            setProblemImagesError("Combined size of all images should be less than 10 MB");
            e.target.value = "";
            return;
        }

        setProblemImages(updatedImages);
        setProblemImagesError("");
        e.target.value = "";
    };

    const removeProblemImage = (index) => {
        const updatedImages = problemImages.filter((_, i) => i !== index);
        setProblemImages(updatedImages);
        setProblemImagesError("");
    };

    const handleEditClick = (index) => {
        setEditingIndex(index);
        editImageRef.current.click();
        setProblemImagesError("");
    };

    const handleReplaceImage = (e) => {
        const file = e.target.files[0];

        if (!file) return;

        const allowedTypes = [
            "image/jpeg",
            "image/png",
            "image/jpg",
            "image/jfif"
        ];

        if (!allowedTypes.includes(file.type)) {
            setProblemImagesError("Only JPG, JPEG, PNG, JFIF files are allowed");
            return;
        }

        const updatedImages = [...problemImages];
        updatedImages[editingIndex] = file;

        const totalSize = updatedImages.reduce((sum, file) => sum + file.size, 0);

        if (totalSize > 10 * 1024 * 1024) {
            setProblemImagesError("Combined size of all images should be less than 10 MB");
            return;
        }

        setProblemImages(updatedImages);
        setEditingIndex(null);
        setProblemImagesError("");
        e.target.value = "";
    };

    const handleBeforeFileChange = (e) => {
        const file = e.target.files[0];

        if (!file) return;

        const allowedTypes = ["image/jpeg", "image/png"];
        const maxSize = 5 * 1024 * 1024;

        if (!allowedTypes.includes(file.type)) {
            setBeforeImageError("Only JPG, JPEG, PNG files are allowed");
            setBeforeImage(null);
            setBeforeImagePreview(ImageIcon);
            return;
        }

        if (file.size > maxSize) {
            setBeforeImageError("Image should be less than 5 MB");
            setBeforeImage(null);
            setBeforeImagePreview(ImageIcon);
            return;
        }

        const imageUrl = URL.createObjectURL(file);

        setBeforeImageError("");
        setBeforeImage(file);
        setBeforeImagePreview(imageUrl);
    };

    const handleAfterFileChange = (e) => {
        const file = e.target.files[0];

        if (!file) return;

        const allowedTypes = ["image/jpeg", "image/png"];
        const maxSize = 5 * 1024 * 1024;

        if (!allowedTypes.includes(file.type)) {
            setAfterImageError("Only JPG, JPEG, PNG files are allowed");
            setAfterImage(null);
            setAfterImagePreview(ImageIcon);
            return;
        }

        if (file.size > maxSize) {
            setAfterImageError("Image should be less than 5 MB");
            setAfterImage(null);
            setAfterImagePreview(ImageIcon);
            return;
        }

        const imageUrl = URL.createObjectURL(file);

        setAfterImageError("");
        setAfterImage(file);
        setAfterImagePreview(imageUrl);
    };

    const handleOpenProblemImageInput = () => {
        problemImageRef.current.click();
    }

    const handleOpenBeforeImageInput = () => {
        beforeImageRef.current.click();
    }

    const handleOpenAfterImageInput = () => {
        afterImageRef.current.click();
    }

    // OBSERVATION & ANALYSIS
    const [observationAnalysis, setObservationAnalysis] = useState("Man");

    // WHAT, WHY ROOT CAUSE
    const [rootCauseProblemStatement, setRootCauseProblemStatement] = useState("");

    const [whyrootcausecount, setWhyRootCauseCount] = useState(1);

    const [whyRootCause, setWhyRootCause] = useState({
        why1: "",
        why2: "",
        why3: "",
        why4: "",
        why5: ""
    })

    const deleteWhyRootCause2 = () => {
        setWhyRootCauseCount(1);
        setWhyRootCause((prev) => ({
            ...prev,
            why2: "",
            why3: "",
            why4: "",
            why5: "",
        }));
    }
    const deleteWhyRootCause3 = () => {
        setWhyRootCauseCount(2);
        setWhyRootCause((prev) => ({
            ...prev,
            why3: "",
            why4: "",
            why5: "",
        }));
    }
    const deleteWhyRootCause4 = () => {
        setWhyRootCauseCount(3);
        setWhyRootCause((prev) => ({
            ...prev,
            why4: "",
            why5: "",
        }));
    }
    const deleteWhyRootCause5 = () => {
        setWhyRootCauseCount(4);
        setWhyRootCause((prev) => ({
            ...prev,
            why5: "",
        }));
    }

    // STANDARDISATION
    const [standardisation, setStandardisation] = useState({
        controlplan: false,
        wis: false,
        pfmea: false,
        pmchecklist: false,
        checksheet: false,
        procedure: false,
        designchange: false,
        others: false
    })

    const handleStandardisationCheckboxChange = (e) => {
        const { id, checked } = e.target;

        setStandardisation((prev) => ({
            ...prev,
            [id]: checked,
        }));
    }

    // DOCUMENT NUMBERS 
    const [documentNumbersRevisionDetails, setDocumentNumbersRevisionDetails] = useState({
        controlplan: "",
        wis: "",
        pfmea: "",
        pmchecklist: "",
        checksheet: "",
        procedure: "",
        designchange: "",
        others: ""
    });

    // SUPPORTING TEAM MEMBERS
    const [supportingTeamMembers, setSupportingTeamMembers] = useState("");

    // DATE FORMAT FOR START & IMPLEMENT

    const formatDate = (date) => {
        if (!date) return "";

        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();

        return `${day}/${month}/${year}`;
    };

    const navigate = useNavigate();

    const ResetPage = () => {
        window.location.href = "/swipex";
    }

    // SUBMIT PROCESS 

    const SubmitRequest = async () => {
        try {
            // VALIDATION FOR ALL THE FIELDS ARE FILLED 
            if (!validateForm()) {
                return;
            }

            setParentLoading(true);

            const formData = new FormData();

            // Employee Details
            formData.append("empid", userDetails.EmpID);
            formData.append("empname", userDetails.EmpName);
            formData.append("empemail", userDetails.EmpEmail);
            formData.append("department", userDetails.Department);
            formData.append("location",  userDetails.Location);
            formData.append("validatorname", userDetails.ReportingManagerName);
            formData.append("validatoremail", userDetails.ReportingManagerEmail);

            // Dates
            formData.append("startdate", formatDate(startDate));
            formData.append("implementdate", formatDate(implementDate));

            // Problem Definition
            formData.append("titleproblemdefinition", sanitizeText(titleProblemDefinition));
            formData.append("whatproblemdefinition", sanitizeText(whatProblemDefinition));
            formData.append("whyproblemdefinition", sanitizeText(whyProblemDefinition));
            formData.append("whenproblemdefinition", sanitizeText(whenProblemDefinition));
            formData.append("howmanyproblemdefinition", sanitizeText(howManyProblemDefinition));

            // Actions
            formData.append("whatactions1", sanitizeText(whatActions.what1));
            formData.append("whatactions2", sanitizeText(whatActions.what2));
            formData.append("whatactions3", sanitizeText(whatActions.what3));
            formData.append("whenactions1", formatDate(whenActions.when1));
            formData.append("whenactions2", formatDate(whenActions.when2));
            formData.append("whenactions3", formatDate(whenActions.when3));
            formData.append("whoactions1", sanitizeText(whoActions.who1));
            formData.append("whoactions2", sanitizeText(whoActions.who2));
            formData.append("whoactions3", sanitizeText(whoActions.who3));
            formData.append("howactions1", sanitizeText(howActions.how1));
            formData.append("howactions2", sanitizeText(howActions.how2));
            formData.append("howactions3", sanitizeText(howActions.how3));

            // Improvements
            formData.append("productivity", improvementCategory.productivity);
            formData.append("productivitytext", sanitizeText(benefits.productivity));

            formData.append("quality", improvementCategory.quality);
            formData.append("qualitytext", sanitizeText(benefits.quality));

            formData.append("cost", improvementCategory.cost);
            formData.append("costtext", sanitizeText(benefits.cost));

            formData.append("delivery", improvementCategory.delivery);
            formData.append("deliverytext", sanitizeText(benefits.delivery));

            formData.append("safety", improvementCategory.safety);
            formData.append("safetytext", sanitizeText(benefits.safety));

            formData.append("morale", improvementCategory.morale);
            formData.append("moraletext", sanitizeText(benefits.morale));

            // Observation Analysis
            formData.append("obervationanalysis", observationAnalysis);

            // Standardisation, Document Numbers & Revision Details
            formData.append("s_controlplan", standardisation.controlplan);
            formData.append("s_controlplantext", sanitizeText(documentNumbersRevisionDetails.controlplan));

            formData.append("s_wis", standardisation.wis);
            formData.append("s_wistext", sanitizeText(documentNumbersRevisionDetails.wis));

            formData.append("s_pfmea", standardisation.pfmea);
            formData.append("s_pfmeatext", sanitizeText(documentNumbersRevisionDetails.pfmea));

            formData.append("s_pmchecklist", standardisation.pmchecklist);
            formData.append("s_pmchecklisttext", sanitizeText(documentNumbersRevisionDetails.pmchecklist));

            formData.append("s_checksheet", standardisation.checksheet);
            formData.append("s_checksheettext", sanitizeText(documentNumbersRevisionDetails.checksheet));

            formData.append("s_procedure", standardisation.procedure);
            formData.append("s_proceduretext", sanitizeText(documentNumbersRevisionDetails.procedure));

            formData.append("s_designchange", standardisation.designchange);
            formData.append("s_designchangetext", sanitizeText(documentNumbersRevisionDetails.designchange));

            formData.append("s_others", standardisation.others);
            formData.append("s_otherstext", sanitizeText(documentNumbersRevisionDetails.others));

            // Root Cause
            formData.append("problemstatement", sanitizeText(rootCauseProblemStatement));
            formData.append("why1", sanitizeText(whyRootCause.why1));
            formData.append("why2", sanitizeText(whyRootCause.why2));
            formData.append("why3", sanitizeText(whyRootCause.why3));
            formData.append("why4", sanitizeText(whyRootCause.why4));
            formData.append("why5", sanitizeText(whyRootCause.why5));

            // Supporting Team Members & Department
            formData.append("supportingteammembers", sanitizeText(supportingTeamMembers));

            // IMAGES 
            formData.append("beforeimage", beforeImage || "");
            formData.append("afterimage", afterImage || "");

            formData.append("problemimage1", problemImages[0] || "");
            formData.append("problemimage2", problemImages[1] || "");
            formData.append("problemimage3", problemImages[2] || "")

            formData.append("problemimagedescription", sanitizeText(imagesDescription.ProblemImageDescription));
            formData.append("beforeimagedescription", sanitizeText(imagesDescription.BeforeImageDescription));
            formData.append("afterimagedescription", sanitizeText(imagesDescription.AfterImageDescription));

            const res = await axios.post(
                SUBMIT_REQUEST,
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    }
                }
            );

            console.log(res.data);
            setErrorMessage("");
            setTimeout(() => {
                setParentLoading(false);
            }, 500);

            // GO TO STATUS TAB AFTER EXECUTING THE FUNCTION
            switchToStatusTab();
        } catch (err) {
            console.error(err);
        }
    }

    const sanitizeText = (text) => {
        return text.replace(/\s+/g, " ").trim();
    };

    // MODALS
    // TO OPEN AND CLOSE THE MODAL
    const [showModal, setShowModal] = useState(false);
    const handleCloseModal = () => {
        setShowModal(false);
    };

    // FORM VALIDATION :

    const validateForm = () => {

        if (startDate == null || startDate == "") {
            setShowModal(true);
            setErrorMessage("Please fill the Start Date");
            return false;
        }

        if (implementDate == null || implementDate == "") {
            setShowModal(true);
            setErrorMessage("Please fill the Implement Date");
            return false;
        }

        // IMPROVEMENT CATEGORY

        if (!Object.values(improvementCategory).some(value => value === true)) {
            setShowModal(true);
            setErrorMessage("Please choose atleast One Improvement category");
            return false;
        }

        // PROBLEM DEFINITION

        if (titleProblemDefinition.trim() == null || titleProblemDefinition.trim() == "") {
            setShowModal(true);
            setErrorMessage("Please fill the Poblem Definition Title");
            return false;
        }

        if (whatProblemDefinition.trim() == null || whatProblemDefinition.trim() == "") {
            setShowModal(true);
            setErrorMessage("Please fill the Poblem Definition What");
            return false;
        }

        if (whyProblemDefinition.trim() == null || whyProblemDefinition.trim() == "") {
            setShowModal(true);
            setErrorMessage("Please fill the Poblem Definition Why");
            return false;
        }

        if (whenProblemDefinition.trim() == null || whenProblemDefinition.trim() == "") {
            setShowModal(true);
            setErrorMessage("Please fill the Poblem Definition When");
            return false;
        }

        if (howManyProblemDefinition.trim() == null || howManyProblemDefinition.trim() == "") {
            setShowModal(true);
            setErrorMessage("Please fill the Poblem Definition How Many");
            return false;
        }

        // PROBLEM IMAGES

        if (problemImages.length === 0) {
            setShowModal(true);
            setErrorMessage("Please choose at Atleast One Problem Image");
            return false;
        }

        if (imagesDescription.ProblemImageDescription.trim() == null || imagesDescription.ProblemImageDescription.trim() == "") {
            setShowModal(true);
            setErrorMessage("Please fill the Description for Problem Image");
            return false;
        }

        // ROOT CAUSE 

        if (rootCauseProblemStatement.trim() == null || rootCauseProblemStatement.trim() == "") {
            setShowModal(true);
            setErrorMessage("Please fill the Root Cause Problem Statement");
            return false;
        }

        if (whyrootcausecount == 1 && (whyRootCause.why1.trim() == null || whyRootCause.why1.trim() == "")) {
            setShowModal(true);
            setErrorMessage("Please fill the Root Cause Why 1");
            return false;
        }

        if (whyrootcausecount == 2 && (whyRootCause.why2.trim() == null || whyRootCause.why2.trim() == "")) {
            setShowModal(true);
            setErrorMessage("Please fill the Root Cause Why 2");
            return false;
        }

        if (whyrootcausecount == 3 && (whyRootCause.why3.trim() == null || whyRootCause.why3.trim() == "")) {
            setShowModal(true);
            setErrorMessage("Please fill the Root Cause Why 3");
            return false;
        }

        if (whyrootcausecount == 4 && (whyRootCause.why4.trim() == null || whyRootCause.why4.trim() == "")) {
            setShowModal(true);
            setErrorMessage("Please fill the Root Cause Why 4");
            return false;
        }

        if (whyrootcausecount == 5 && (whyRootCause.why5.trim() == null || whyRootCause.why5.trim() == "")) {
            setShowModal(true);
            setErrorMessage("Please fill the Root Cause Why 5");
            return false;
        }

        // ACTION COUNT

        if (whatactionscount == 1 && (whatActions.what1.trim() == null || whatActions.what1.trim() == "")) {
            setShowModal(true);
            setErrorMessage("Please fill the Actions What 1");
            return false;
        }

        // ACTION - I

        if (whatactionscount == 1 && (whatActions.what1.trim() == null || whatActions.what1.trim() == "")) {
            setShowModal(true);
            setErrorMessage("Please fill the Actions - I - What 1");
            return false;
        }

        if (whatactionscount == 1 && (whenActions.when1 == null || whenActions.when1 == "")) {
            setShowModal(true);
            setErrorMessage("Please fill the Actions - I - When 1");
            return false;
        }

        if (whatactionscount == 1 && (whoActions.who1.trim() == null || whoActions.who1.trim() == "")) {
            setShowModal(true);
            setErrorMessage("Please fill the Actions - I - Who 1");
            return false;
        }

        if (whatactionscount == 1 && (howActions.how1.trim() == null || howActions.how1.trim() == "")) {
            setShowModal(true);
            setErrorMessage("Please fill the Actions - I - How 1");
            return false;
        }

        // ACTION - II

        if (whatactionscount == 2 && (whatActions.what2.trim() == null || whatActions.what2.trim() == "")) {
            setShowModal(true);
            setErrorMessage("Please fill the Actions - II - What 2");
            return false;
        }

        if (whatactionscount == 2 && (whenActions.when2 == null || whenActions.when2 == "")) {
            setShowModal(true);
            setErrorMessage("Please fill the Actions - II - When 2");
            return false;
        }

        if (whatactionscount == 2 && (whoActions.who2.trim() == null || whoActions.who2.trim() == "")) {
            setShowModal(true);
            setErrorMessage("Please fill the Actions - II - Who 2");
            return false;
        }

        if (whatactionscount == 2 && (howActions.how2.trim() == null || howActions.how2.trim() == "")) {
            setShowModal(true);
            setErrorMessage("Please fill the Actions - II - How 2");
            return false;
        }

        // ACTION - III

        if (whatactionscount == 3 && (whatActions.what3.trim() == null || whatActions.what3.trim() == "")) {
            setShowModal(true);
            setErrorMessage("Please fill the Actions - III - What 3");
            return false;
        }

        if (whatactionscount == 3 && (whenActions.when3 == null || whenActions.when3 == "")) {
            setShowModal(true);
            setErrorMessage("Please fill the Actions - III - When 3");
            return false;
        }

        if (whatactionscount == 3 && (whoActions.who3.trim() == null || whoActions.who3.trim() == "")) {
            setShowModal(true);
            setErrorMessage("Please fill the Actions - III - Who 3");
            return false;
        }

        if (whatactionscount == 3 && (howActions.how3.trim() == null || howActions.how3.trim() == "")) {
            setShowModal(true);
            setErrorMessage("Please fill the Actions - III - How 3");
            return false;
        }

        // BEFORE IMAGE 

        if (!beforeImage) {
            setShowModal(true);
            setErrorMessage("Please choose the Before Image");
            return false;
        }

        if (imagesDescription.BeforeImageDescription.trim() == null || imagesDescription.BeforeImageDescription.trim() == "") {
            setShowModal(true);
            setErrorMessage("Please fill the Description for Before Image");
            return false;
        }

        // AFTER IMAGE 

        if (!afterImage) {
            setShowModal(true);
            setErrorMessage("Please choose the After Image");
            return false;
        }

        if (imagesDescription.AfterImageDescription.trim() == null || imagesDescription.AfterImageDescription.trim() == "") {
            setShowModal(true);
            setErrorMessage("Please fill the Description for After Image");
            return false;
        }

        // STANDARDISATION

        if (!Object.values(standardisation).some(value => value === true)) {
            setShowModal(true);
            setErrorMessage("Please choose atleast One Standardisation");
            return false;
        }

        // DOCUMENT NUMBERS & REVISION DETAILS

        if (standardisation.controlplan == true && (documentNumbersRevisionDetails.controlplan.trim() == null || documentNumbersRevisionDetails.controlplan.trim() == "")) {
            setShowModal(true);
            setErrorMessage("Please fill the Document Numbers & Revision Details Control Plan");
            return false;
        }

        if (standardisation.wis == true && (documentNumbersRevisionDetails.wis.trim() == null || documentNumbersRevisionDetails.wis.trim() == "")) {
            setShowModal(true);
            setErrorMessage("Please fill the Document Numbers & Revision Details WIS");
            return false;
        }

        if (standardisation.pfmea == true && (documentNumbersRevisionDetails.pfmea.trim() == null || documentNumbersRevisionDetails.pfmea.trim() == "")) {
            setShowModal(true);
            setErrorMessage("Please fill the Document Numbers & Revision Details PFMEA");
            return false;
        }

        if (standardisation.pmchecklist == true && (documentNumbersRevisionDetails.pmchecklist.trim() == null || documentNumbersRevisionDetails.pmchecklist.trim() == "")) {
            setShowModal(true);
            setErrorMessage("Please fill the Document Numbers & Revision Details PM Check List");
            return false;
        }

        if (standardisation.checksheet == true && (documentNumbersRevisionDetails.checksheet.trim() == null || documentNumbersRevisionDetails.checksheet.trim() == "")) {
            setShowModal(true);
            setErrorMessage("Please fill the Document Numbers & Revision Details Check Sheet");
            return false;
        }

        if (standardisation.procedure == true && (documentNumbersRevisionDetails.procedure.trim() == null || documentNumbersRevisionDetails.procedure.trim() == "")) {
            setShowModal(true);
            setErrorMessage("Please fill the Document Numbers & Revision Details Procedure");
            return false;
        }

        if (standardisation.designchange == true && (documentNumbersRevisionDetails.designchange.trim() == null || documentNumbersRevisionDetails.designchange.trim() == "")) {
            setShowModal(true);
            setErrorMessage("Please fill the Document Numbers & Revision Details Design Change");
            return false;
        }

        if (standardisation.others == true && (documentNumbersRevisionDetails.others.trim() == null || documentNumbersRevisionDetails.others.trim() == "")) {
            setShowModal(true);
            setErrorMessage("Please fill the Document Numbers & Revision Details Check Sheet");
            return false;
        }

        // BENEFITS

        if (improvementCategory.productivity == true && (benefits.productivity.trim() == null || benefits.productivity.trim() == "")) {
            setShowModal(true);
            setErrorMessage("Please fill the Benefits Productivity");
            return false;
        }

        if (improvementCategory.quality == true && (benefits.quality.trim() == null || benefits.quality.trim() == "")) {
            setShowModal(true);
            setErrorMessage("Please fill the Benefits Quality");
            return false;
        }

        if (improvementCategory.cost == true && (benefits.cost.trim() == null || benefits.cost.trim() == "")) {
            setShowModal(true);
            setErrorMessage("Please fill the Benefits Cost");
            return false;
        }

        if (improvementCategory.delivery == true && (benefits.delivery.trim() == null || benefits.delivery.trim() == "")) {
            setShowModal(true);
            setErrorMessage("Please fill the Benefits Delivery");
            return false;
        }

        if (improvementCategory.safety == true && (benefits.safety.trim() == null || benefits.safety.trim() == "")) {
            setShowModal(true);
            setErrorMessage("Please fill the Benefits Safety");
            return false;
        }

        if (improvementCategory.morale == true && (benefits.morale.trim() == null || benefits.morale.trim() == "")) {
            setShowModal(true);
            setErrorMessage("Please fill the Benefits Morale");
            return false;
        }

        // SUPPORTING TEAM MEMBERS & DEPARTMENTS 

        if (supportingTeamMembers.trim() == null || supportingTeamMembers.trim() == "") {
            setShowModal(true);
            setErrorMessage("Please fill the Suuporting Team Members & Department");
            return false;
        }


        return true;
    };

    return (
        <div style={{ fontFamily: "Aptos, 'Aptos Body', sans-serif", }}>

            {/* PROJECT DETAILS */}

            <div className="container">
                <div className="row">
                    <div className="col-1"></div>
                    <div className="col-10">
                        <b style={{ fontSize: "15px", color: "papayawhip" }}>Project Details</b>
                        <div style={{ background: "linear-gradient(to bottom, #f0fbff 0%, powderblue 100%)", width: "100%", height: "auto", borderRadius: "10px" }}>
                            <div class="alert alert-success" role="alert" style={{ fontSize: "12px", lineHeight: 1, }}>
                                <p class="alert-heading" style={{ fontWeight: "bold" }}>Dear {userDetails.EmpName}...!</p>
                                <p>If any of your personal details are missing or incorrect, please contact the Administrator (itconnect@switchmobilityev.com) for assistance.</p>
                                <p class="mb-0">Please ensure that all your details are accurate and up to date to the best of your knowledge before submitting any Continual Improvements.</p>
                            </div>
                            {missingFields.length > 0 ? (
                                <p className="pt-2 fw-bold small" style={{ color: "red" }}>
                                    You don't have the following details: {missingFields.join(", ")}.
                                    Please contact the IT team.
                                </p>
                            ) : null}
                            <div className="row pt-2">
                                <div className="col-5">
                                    <h6 className="fw-bold" style={{ fontSize: "13px" }}>Leader Name / Emp Name</h6>
                                </div>
                                <div className="col-5">
                                    <p className="text-primary fw-bold">{userDetails.EmpName}</p>
                                </div>
                                <div className="col-2">
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-5">
                                    <h6 className="fw-bold" style={{ fontSize: "13px" }}>Emp Email</h6>
                                </div>
                                <div className="col-5">
                                    <p className="text-primary fw-bold">{userDetails.EmpEmail}</p>
                                </div>
                                <div className="col-2">
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-5">
                                    <h6 className="fw-bold" style={{ fontSize: "13px" }}>Emp ID / No.</h6>
                                </div>
                                <div className="col-5">
                                    <p className="text-primary fw-bold">{userDetails.EmpID}</p>
                                </div>
                                <div className="col-2">
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-5">
                                    <h6 className="fw-bold" style={{ fontSize: "13px" }}>Department</h6>
                                </div>
                                <div className="col-5">
                                    <p className="text-primary fw-bold">{userDetails.Department}</p>
                                </div>
                                <div className="col-2">
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-5">
                                    <h6 className="fw-bold" style={{ fontSize: "13px" }}>Location</h6>
                                </div>
                                <div className="col-5">
                                    <p className="text-primary fw-bold">{userDetails.Location}</p>
                                </div>
                                <div className="col-2">
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-5">
                                    <h6 className="fw-bold" style={{ fontSize: "13px" }}>Reporting Manager Name</h6>
                                </div>
                                <div className="col-5">
                                    <p className="text-primary fw-bold">{userDetails.ReportingManagerName}</p>
                                </div>
                                <div className="col-2">
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-5">
                                    <h6 className="fw-bold" style={{ fontSize: "13px" }}>Reporting Manager Email</h6>
                                </div>
                                <div className="col-5">
                                    <p className="text-primary fw-bold">{userDetails.ReportingManagerEmail}</p>
                                </div>
                                <div className="col-2">
                                </div>
                            </div>

                            <div className="row pb-3">
                                <div className="col-5">
                                    <h6 className="fw-bold" style={{ fontSize: "13px" }}>Start Date</h6>
                                </div>
                                <div className="col-5">
                                    <DatePicker wrapperClassName="w-50" placeholderText="Pick a Date" dateFormat="dd/MM/yyyy" className="form-control px-1 py-0 rounded-0 dual-border-datepicker"
                                        selected={startDate} onChange={(date) => setStartDate(date)} onKeyDown={(e) => e.preventDefault()} minDate={minDate} maxDate={implementDate || maxDate} showMonthDropdown showYearDropdown dropdownMode="select" yearDropdownItemNumber={3} />
                                </div>
                                <div className="col-2">
                                </div>
                            </div>

                            <div className="row mt-1 pb-3">
                                <div className="col-5">
                                    <h6 className="fw-bold" style={{ fontSize: "13px" }}>Implement Date</h6>
                                </div>
                                <div className="col-5">
                                    <DatePicker wrapperClassName="w-50" placeholderText="Pick a Date" dateFormat="dd/MM/yyyy" className="form-control px-1 py-0 rounded-0 dual-border-datepicker"
                                        selected={implementDate} onChange={(date) => setImplementDate(date)} onKeyDown={(e) => e.preventDefault()} minDate={startDate || minDate} maxDate={maxDate} showMonthDropdown showYearDropdown dropdownMode="select" yearDropdownItemNumber={3} />
                                </div>
                                <div className="col-2">
                                </div>
                            </div>


                        </div>
                    </div>
                    <div className="col-1"></div>
                </div>
            </div>

            {/* BORDER */}

            <div className="my-2" style={{ width: "100%", overflow: "hidden", whiteSpace: "nowrap", lineHeight: 1, fontSize: "14px", color: "lightgray" }} >
                {"+ - ".repeat(1000)}
            </div>

            {/* IMPROVEMNT CATEGORY */}

            <div className="container" >
                <div className="row">
                    <b style={{ fontSize: "15px", color: "papayawhip" }}>Improvement Category</b>
                    <div className="mb-2" style={{ background: "linear-gradient(to bottom, #f0fbff 0%, powderblue 100%)", width: "100%", height: "auto", borderRadius: "10px", fontStyle: "italic" }}>
                        <div className="row">
                            <div className="col-12">
                                <div style={{ display: "flex", justifyContent: "space-evenly", alignItems: "center" }} className="ps-5" >
                                    <input type="checkbox" id="productivity" name="productivity" className="custom-checkbox" style={{ transform: "scale(1.5)", cursor: "pointer" }} onChange={(e) => { handleImprovementCategoryCheckboxChange(e); setBenefits((prev) => ({ ...prev, productivity: "" })) }} />
                                    <label htmlFor="productivity" style={{ cursor: "pointer" }}>Productivity</label>

                                    <input type="checkbox" id="quality" name="quality" className="custom-checkbox" style={{ transform: "scale(1.5)", cursor: "pointer" }} onChange={(e) => { handleImprovementCategoryCheckboxChange(e); setBenefits((prev) => ({ ...prev, quality: "" })) }} />
                                    <label htmlFor="quality" style={{ cursor: "pointer" }}>Quality</label>

                                    <input type="checkbox" id="cost" name="cost" className="custom-checkbox" style={{ transform: "scale(1.5)", cursor: "pointer" }} onChange={(e) => { handleImprovementCategoryCheckboxChange(e); setBenefits((prev) => ({ ...prev, cost: "" })) }} />
                                    <label htmlFor="cost" style={{ cursor: "pointer" }}>Cost</label>

                                    <input type="checkbox" id="delivery" name="delivery" className="custom-checkbox" style={{ transform: "scale(1.5)", cursor: "pointer" }} onChange={(e) => { handleImprovementCategoryCheckboxChange(e); setBenefits((prev) => ({ ...prev, delivery: "" })) }} />
                                    <label htmlFor="delivery" style={{ cursor: "pointer" }}>Delivery</label>

                                    <input type="checkbox" id="safety" name="safety" className="custom-checkbox" style={{ transform: "scale(1.5)", cursor: "pointer" }} onChange={(e) => { handleImprovementCategoryCheckboxChange(e); setBenefits((prev) => ({ ...prev, safety: "" })) }} />
                                    <label htmlFor="safety" style={{ cursor: "pointer" }}>Safety</label>

                                    <input type="checkbox" id="morale" name="morale" className="custom-checkbox" style={{ transform: "scale(1.5)", cursor: "pointer" }} onChange={(e) => { handleImprovementCategoryCheckboxChange(e); setBenefits((prev) => ({ ...prev, morale: "" })) }} />
                                    <label htmlFor="morale" style={{ cursor: "pointer" }}>Morale</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

            {/* BORDER */}

            <div className="my-2" style={{ width: "100%", overflow: "hidden", whiteSpace: "nowrap", lineHeight: 1, fontSize: "14px", color: "lightgray" }} >
                {"+ - ".repeat(1000)}
            </div>


            {/* PROBLEM DEFINITION  */}

            <div className="container">
                <div className="row">
                    <b style={{ fontSize: "15px", color: "papayawhip" }}>Problem Definition (1T 3W 1H)</b>
                    <div className="pt-4 mb-2 pb-4" style={{ background: "linear-gradient(to bottom, #f0fbff 0%, powderblue 100%)", width: "100%", height: "auto", borderRadius: "10px" }}>
                        {/* Title */}
                        <div className="row" style={{ alignItems: "center" }}>
                            <div className="col-3">
                            </div>
                            <div className="col-1 pt-3">
                                <h6 className="fw-bold" style={{ fontSize: "13px", textAlign: "end", }}>Title :</h6>
                            </div>
                            <div className="col-5 p-0">
                                <textarea rows="1" maxLength={90} placeholder="Title..." id="titleproblemdescription" name="titleproblemdescription" className="form-control px-1"
                                    style={{ borderTopLeftRadius: "20px", borderBottomRightRadius: "25px" }} value={titleProblemDefinition} onChange={(e) => setTitleProblemDefinition(e.target.value)} />
                            </div>
                            <div className="col-3">
                            </div>

                        </div>

                        <div className="row">
                            <div className="col-6 mt-4">
                                <h6 className="fw-bold" style={{ fontSize: "13px", textAlign: "center", }}>What :</h6>
                                <textarea type="text" rows="2" maxLength={190} placeholder="Problem Description..." id="whatproblemdescription" name="whatproblemdescription" className="form-control px-1"
                                    style={{ borderRadius: "10px", }} value={whatProblemDefinition} onChange={(e) => setWhatProblemDefinition(e.target.value)} />
                            </div>
                            <div className="col-6 mt-4">
                                <h6 className="fw-bold" style={{ fontSize: "13px", textAlign: "center", }}>Why :</h6>
                                <textarea type="text" rows="2" maxLength={190} placeholder="Effect of the Problem..." id="whyproblemdescription" name="whyproblemdescription" className="form-control px-1"
                                    style={{ borderRadius: "10px", }} value={whyProblemDefinition} onChange={(e) => setWhyProblemDefinition(e.target.value)} />
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-6 mt-4">
                                <h6 className="fw-bold" style={{ fontSize: "13px", textAlign: "center", }}>When :</h6>
                                <textarea type="text" rows="2" maxLength={190} placeholder="Date / Period of the Problem..." id="whenproblemdescription" name="whenproblemdescription" className="form-control px-1"
                                    style={{ borderRadius: "10px", }} value={whenProblemDefinition} onChange={(e) => setWhenProblemDefinition(e.target.value)} />
                            </div>
                            <div className="col-6 mt-4">
                                <h6 className="fw-bold" style={{ fontSize: "13px", textAlign: "center", }}>How Many :</h6>
                                <textarea type="text" rows="2" maxLength={190} placeholder="Quantity of the Problem..." id="howmanyproblemdescription" name="howmanyproblemdescription" className="form-control px-1"
                                    style={{ borderRadius: "10px", }} value={howManyProblemDefinition} onChange={(e) => setHowManyProblemDefinition(e.target.value)} />
                            </div>
                        </div>

                    </div>
                </div>

            </div>

            {/* BORDER */}

            <div className="my-2" style={{ width: "100%", overflow: "hidden", whiteSpace: "nowrap", lineHeight: 1, fontSize: "14px", color: "lightgray" }} >
                {"+ - ".repeat(1000)}
            </div>

            {/* PROBLEM IMAGES */}

            <div className="container">
                <div className="row">
                    {/* Problem Images */}
                    <div className="col-12">
                        <b style={{ fontSize: "15px", color: "papayawhip" }}>Problem / Present Status <br></br>(Include pictures / diagrams, etc..,)</b>
                        <div className="pt-3 mb-2 pb-2" style={{ background: "linear-gradient(to bottom, #f0fbff 0%, powderblue 100%)", width: "100%", height: "auto", borderRadius: "10px" }}>
                            <div className="d-flex justify-content-center gap-3 mt-3">
                                {[0, 1, 2].map((index) => {
                                    const file = problemImages[index];
                                    const preview = file ? URL.createObjectURL(file) : null;

                                    const canUpload =
                                        index === 0 || !!problemImages[index - 1];

                                    return (
                                        <div className={index == 0 || index == 1 ? "border-primary border-2 border-end" : null}
                                            key={index}
                                            style={{
                                                width: "400px",
                                                display: "flex",
                                                flexDirection: "column",
                                                alignItems: "center",
                                            }}
                                        >
                                            {preview ? (
                                                <>
                                                    {/* Toolbar */}
                                                    <div
                                                        className="d-flex justify-content-end gap-2 mb-2"
                                                        style={{ width: "200px" }}
                                                    >
                                                        <i
                                                            className="bi bi-pencil-square"
                                                            title="Edit Image"
                                                            onClick={() => handleEditClick(index)}
                                                            style={{
                                                                color: "blue",
                                                                cursor: "pointer",
                                                                fontSize: "18px",
                                                            }}
                                                        />
                                                        <i
                                                            className="bi bi-trash3-fill"
                                                            title="Delete Image"
                                                            onClick={() => removeProblemImage(index)}
                                                            style={{
                                                                color: "red",
                                                                cursor: "pointer",
                                                                fontSize: "18px",
                                                            }}
                                                        />
                                                    </div>

                                                    {/* Image */}
                                                    <img
                                                        src={preview}
                                                        alt={`Preview ${index + 1}`}
                                                        style={{
                                                            width: "250px",
                                                            height: "180px",
                                                            objectFit: "fill", // Fill the border completely
                                                            border: "1px solid #ddd",
                                                            borderRadius: "8px",
                                                        }}
                                                    />
                                                </>
                                            ) : (
                                                <div
                                                    className="d-flex justify-content-center align-items-center"
                                                    style={{
                                                        width: "180px",
                                                        height: "208px", // 180px image + ~28px toolbar space
                                                    }}
                                                >
                                                    <img
                                                        src={canUpload ? ImageIcon : ImageIconDull}
                                                        alt="Upload"
                                                        onClick={
                                                            canUpload
                                                                ? handleOpenProblemImageInput
                                                                : undefined
                                                        }
                                                        style={{
                                                            width: "50px",
                                                            height: "50px",
                                                            cursor: canUpload ? "pointer" : "default",
                                                            objectFit: "contain",
                                                        }}
                                                    />
                                                </div>
                                            )}
                                        </div>
                                    );
                                })}
                            </div>
                            <input ref={problemImageRef} hidden type="file" multiple className="form-control mt-3" accept=".jpg,.jpeg,.png,.jfif" onChange={handleProblemImagesChange} />
                            <br></br><p className="text-success fw-bold" style={{ fontSize: "13px" }}>maxmimum 10 MB of attachments allowed (all 3 images combined)</p>

                            {/* Hidden input used for editing */}
                            <input ref={editImageRef} type="file" accept=".jpg,.jpeg,.png,.jfif" style={{ display: "none" }} onChange={handleReplaceImage} />

                            {problemImagesError && (<p className="text-danger fw-bold" style={{ fontSize: "13px" }}>{problemImagesError}</p>)}


                            <div className="mx-3">
                                <h6 className="fw-bold" style={{ fontSize: "15px", textAlign: "start", }}> Description :</h6>
                                <textarea type="text" rows="2" maxLength={190} placeholder="Description of the Problem Image..." id="problemimagedescription" name="problemimagedescription" className="form-control px-1"
                                    style={{ borderRadius: "10px", }} value={imagesDescription.ProblemImageDescription} onChange={(e) => setImagesDescription({ ...imagesDescription, ProblemImageDescription: e.target.value })} />
                            </div>

                        </div>
                    </div>

                </div>

            </div>

            {/* BORDER */}

            <div className="my-2" style={{ width: "100%", overflow: "hidden", whiteSpace: "nowrap", lineHeight: 1, fontSize: "14px", color: "lightgray" }} >
                {"+ - ".repeat(1000)}
            </div>

            {/* OBSERVATION & ANALYSIS */}

            <div className="container" >
                <div className="row">
                    <div className="col-3"></div>

                    <div className="col-6">

                        <b style={{ fontSize: "15px", color: "papayawhip" }}>Observation & Analysis</b>
                        <div style={{ background: "linear-gradient(to bottom, #f0fbff 0%, powderblue 100%)", width: "100%", height: "auto", borderRadius: "10px", fontStyle: "italic" }}>

                            <div className="ps-5 d-flex align-items-center gap-4" >
                                <div className="d-flex align-items-center" >
                                    <input checked={observationAnalysis === "Man"} onChange={() => setObservationAnalysis("Man")} type="radio" id="oa1" name="oa" value="Man" style={{ width: "16px", height: "16px", accentColor: "blue", verticalAlign: "middle" }} />
                                    <label htmlFor="oa1" className="ms-2 mb-0" style={{ cursor: "pointer" }}> Man </label>
                                </div>
                                <div className="d-flex align-items-center">
                                    <input checked={observationAnalysis === "Machine"} onChange={() => setObservationAnalysis("Machine")} type="radio" id="oa2" name="oa" value="Machine" style={{ width: "16px", height: "16px", accentColor: "blue", verticalAlign: "middle" }} />
                                    <label htmlFor="oa2" className="ms-2 mb-0" style={{ cursor: "pointer" }}> Machine </label>
                                </div>
                                <div className="d-flex align-items-center">
                                    <input checked={observationAnalysis === "Method"} onChange={() => setObservationAnalysis("Method")} type="radio" id="oa3" name="oa" value="Method" style={{ width: "16px", height: "16px", accentColor: "blue", verticalAlign: "middle" }} />
                                    <label htmlFor="oa3" className="ms-2 mb-0" style={{ cursor: "pointer" }}> Method </label>
                                </div>
                                <div className="d-flex align-items-center">
                                    <input checked={observationAnalysis === "Material"} onChange={() => setObservationAnalysis("Material")} type="radio" id="oa4" name="oa" value="Material" style={{ width: "16px", height: "16px", accentColor: "blue", verticalAlign: "middle" }} />
                                    <label htmlFor="oa4" className="ms-2 mb-0" style={{ cursor: "pointer" }}> Material </label>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div className="col-3"></div>
                </div>
            </div>

            {/* BORDER */}

            <div className="my-2" style={{ width: "100%", overflow: "hidden", whiteSpace: "nowrap", lineHeight: 1, fontSize: "14px", color: "lightgray" }} >
                {"+ - ".repeat(1000)}
            </div>

            {/* ROOT CAUSE */}

            <div className="container">
                <div className="row">
                    <div className="col-6">
                        <b style={{ fontSize: "15px", color: "papayawhip" }}>Root Cause</b>
                        <div className="pt-3 mb-2 pb-2" style={{ background: "linear-gradient(to bottom, #f0fbff 0%, powderblue 100%)", width: "100%", height: "auto", borderRadius: "30px" }}>
                            <div className="row m-2 pb-4" style={{ alignItems: "center" }}>
                                <div className="col-12">
                                    <h6 className="fw-bold" style={{ fontSize: "13px", textAlign: "start", }}>Problem Statement :</h6>
                                    <textarea type="text" rows="10" maxLength={190} placeholder="Problem Statement..." id="problemstatement" name="problemstatement" className="form-control px-1"
                                        style={{ borderRadius: "10px", }} value={rootCauseProblemStatement} onChange={(e) => setRootCauseProblemStatement(e.target.value)} />
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* WHY */}
                    <div className="col-6">
                        {/* 1,2 */}
                        <div className="row">

                            {/* WHY 1 */}
                            <div className="col-6">

                                <h6 className="fw-bold" style={{ fontSize: "13px", textAlign: "center", color: "papayawhip" }}>Why 1 :</h6>
                                <div style={{ display: "flex", justifyContent: "space-between" }}>
                                    <textarea type="text" rows="2" maxLength={190} placeholder="Description..." id="whyrootcause1" name="whyrootcause1" className="form-control px-1"
                                        style={{ borderRadius: "10px", }} value={whyRootCause.why1} onChange={(e) => setWhyRootCause({ ...whyRootCause, why1: e.target.value })} />
                                    {whyrootcausecount <= 1 && <i class="bi bi-patch-plus-fill mt-3 ps-1" style={{ color: "white", cursor: "pointer", }} title="add new why 2" onClick={() => setWhyRootCauseCount(2)}></i>}
                                </div>

                            </div>

                            {/* WHY 2 */}
                            <div className="col-6">

                                {whyrootcausecount > 1 && <>
                                    <h6 className="fw-bold" style={{ fontSize: "13px", textAlign: "center", color: "papayawhip" }}>Why 2 :</h6>
                                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                                        <textarea type="text" rows="2" maxLength={190} placeholder="Description..." id="whyrootcause2" name="whyrootcause2" className="form-control px-1"
                                            style={{ borderRadius: "10px", }} value={whyRootCause.why2} onChange={(e) => setWhyRootCause({ ...whyRootCause, why2: e.target.value })} />
                                        <div className="mt-1">
                                            {whyrootcausecount <= 2 && <i class="bi bi-trash3-fill" style={{ color: "red", cursor: "pointer" }} title="delete why 2" onClick={deleteWhyRootCause2}></i>}
                                            {whyrootcausecount <= 2 && <i class="bi bi-patch-plus-fill" style={{ color: "white", cursor: "pointer", }} title="add new why 3" onClick={() => setWhyRootCauseCount(3)}></i>}
                                        </div>
                                    </div>
                                </>}
                            </div>

                        </div>

                        {/* 3,4 */}

                        <div className="row mt-2">
                            {/* WHY 3 */}
                            <div className="col-6">
                                {whyrootcausecount > 2 && <>
                                    <h6 className="fw-bold" style={{ fontSize: "13px", textAlign: "center", color: "papayawhip" }}>Why 3 :</h6>
                                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                                        <textarea type="text" rows="2" maxLength={190} placeholder="Description..." id="whyrootcause3" name="whyrootcause3" className="form-control px-1"
                                            style={{ borderRadius: "10px", }} value={whyRootCause.why3} onChange={(e) => setWhyRootCause({ ...whyRootCause, why3: e.target.value })} />
                                        <div className="mt-1">
                                            {whyrootcausecount <= 3 && <i class="bi bi-trash3-fill" style={{ color: "red", cursor: "pointer" }} title="delete why 3" onClick={deleteWhyRootCause3}></i>}
                                            {whyrootcausecount <= 3 && <i class="bi bi-patch-plus-fill" style={{ color: "white", cursor: "pointer", }} title="add new why 4" onClick={() => setWhyRootCauseCount(4)}></i>}
                                        </div>
                                    </div>
                                </>}
                            </div>

                            {/* WHY 4 */}
                            <div className="col-6">
                                {whyrootcausecount > 3 && <>
                                    <h6 className="fw-bold" style={{ fontSize: "13px", textAlign: "center", color: "papayawhip" }}>Why 4 :</h6>
                                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                                        <textarea type="text" rows="2" maxLength={190} placeholder="Description..." id="whyrootcause4" name="whyrootcause4" className="form-control px-1"
                                            style={{ borderRadius: "10px", }} value={whyRootCause.why4} onChange={(e) => setWhyRootCause({ ...whyRootCause, why4: e.target.value })} />
                                        <div className="mt-1">
                                            {whyrootcausecount <= 4 && <i class="bi bi-trash3-fill" style={{ color: "red", cursor: "pointer" }} title="delete why 4" onClick={deleteWhyRootCause4}></i>}
                                            {whyrootcausecount <= 4 && <i class="bi bi-patch-plus-fill" style={{ color: "white", cursor: "pointer", }} title="add new why 5" onClick={() => setWhyRootCauseCount(5)}></i>}
                                        </div>
                                    </div>
                                </>}
                            </div>
                        </div>

                        {/* 5 */}

                        <div className="row mt-2">
                            <div className="col-3"></div>
                            {/* WHY 5 */}
                            <div className="col-6">
                                {whyrootcausecount > 4 && <>
                                    <h6 className="fw-bold" style={{ fontSize: "13px", textAlign: "center", color: "papayawhip" }}>Why 5 :</h6>
                                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                                        <textarea type="text" rows="2" maxLength={190} placeholder="Description..." id="whyrootcause5" name="whyrootcause5" className="form-control px-1"
                                            style={{ borderRadius: "10px", }} value={whyRootCause.why5} onChange={(e) => setWhyRootCause({ ...whyRootCause, why5: e.target.value })} />
                                        {whyrootcausecount <= 5 && <i class="bi bi-trash3-fill mt-3" style={{ color: "red", cursor: "pointer" }} title="delete why 5" onClick={deleteWhyRootCause5}></i>}
                                    </div>
                                </>}
                            </div>
                            <div className="col-3"></div>

                        </div>



                    </div>

                </div>

            </div>

            {/* BORDER */}

            <div className="my-2" style={{ width: "100%", overflow: "hidden", whiteSpace: "nowrap", lineHeight: 1, fontSize: "14px", color: "lightgray" }} >
                {"+ - ".repeat(1000)}
            </div>

            {/* ACTIONS */}

            <div className="container">
                <div className="row">

                    <b style={{ fontSize: "15px", color: "papayawhip" }}>Actions (3W 1H)</b>

                    {/* actions 1 */}
                    <div className="pt-3 mb-2 pb-2" style={{ background: "linear-gradient(to bottom, #f0fbff 0%, powderblue 100%)", width: "100%", height: "auto", borderRadius: "10px" }}>
                        <b style={{ color: "green", display: "block", textAlign: "start", fontSize: "15px", }}>Action - I</b>
                        <div className="row m-2" style={{ alignItems: "center" }}>
                            <div className="col-9">
                                <h6 className="fw-bold" style={{ fontSize: "13px", textAlign: "center", }}>What 1 :</h6>
                                <textarea rows="2" maxLength={150} placeholder="Description..." id="whatactions1" name="whatactions1" className="form-control px-1"
                                    style={{ borderRadius: "10px", }} value={whatActions.what1} onChange={(e) => setWhatActions({ ...whatActions, what1: e.target.value })} />
                            </div>
                            <div className="col-3" style={{ alignContent: "center" }}>
                                <h6 className="fw-bold" style={{ fontSize: "13px", textAlign: "center", }}>When 1 :</h6>
                                <DatePicker placeholderText="Pick a Date" dateFormat="dd/MM/yyyy" className="form-control px-1 py-0 rounded-0 dual-border-datepicker"
                                    selected={whenActions.when1} onChange={(date) => setWhenActions({ ...whenActions, when1: date })} onKeyDown={(e) => e.preventDefault()} minDate={minDate} maxDate={maxDate} showMonthDropdown showYearDropdown dropdownMode="select" yearDropdownItemNumber={3} />
                            </div>
                        </div>

                        <div className="row m-2 pb-1 pt-2">
                            <div className="col-6">
                                <h6 className="fw-bold" style={{ fontSize: "13px", textAlign: "center", }}>Who 1 :</h6>
                                <textarea rows="2" maxLength={150} placeholder="Description..." id="whoactions1" name="whoactions1" className="form-control px-1"
                                    style={{ borderRadius: "10px", }} value={whoActions.who1} onChange={(e) => setWhoActions({ ...whoActions, who1: e.target.value })} />
                            </div>
                            <div className="col-6">
                                <h6 className="fw-bold" style={{ fontSize: "13px", textAlign: "center", }}>How 1 :</h6>
                                <textarea rows="2" maxLength={150} placeholder="Description..." id="howactions1" name="howactions1" className="form-control px-1"
                                    style={{ borderRadius: "10px", }} value={howActions.how1} onChange={(e) => setHowActions({ ...howActions, how1: e.target.value })} />
                            </div>
                        </div>


                        <div className="me-3" style={{ textAlign: "end", minHeight: "24px", }}>
                            {whatactionscount <= 1 &&
                                <Icon sx={{ color: green[500], cursor: "pointer" }} title="Add Action 2" onClick={() => setWhatActionsCount(2)}>
                                    add_circle
                                </Icon>
                            }
                        </div>
                    </div>

                    {/* actions 2 */}
                    {whatactionscount > 1 && <>
                        <div className="pt-3 mb-2 pb-2" style={{ background: "linear-gradient(to bottom, #f0fbff 0%, powderblue 100%)", width: "100%", height: "auto", borderRadius: "10px" }}>
                            <b style={{ color: "green", display: "block", textAlign: "start", fontSize: "15px", }}>Action - II</b>
                            <div className="row m-2" style={{ alignItems: "center" }}>
                                <div className="col-9">
                                    <h6 className="fw-bold" style={{ fontSize: "13px", textAlign: "center", }}>What 2 :</h6>
                                    <textarea rows="2" maxLength={150} placeholder="Description..." id="whatactions2" name="whatactions2" className="form-control px-1"
                                        style={{ borderRadius: "10px", }} value={whatActions.what2} onChange={(e) => setWhatActions({ ...whatActions, what2: e.target.value })} />
                                </div>
                                <div className="col-3" style={{ alignContent: "center" }}>
                                    <h6 className="fw-bold" style={{ fontSize: "13px", textAlign: "center", }}>When 2 :</h6>
                                    <DatePicker placeholderText=" Pick a Date" dateFormat="dd/MM/yyyy" className="form-control px-1 py-0 rounded-0 dual-border-datepicker"
                                        selected={whenActions.when2} onChange={(date) => setWhenActions({ ...whenActions, when2: date })} onKeyDown={(e) => e.preventDefault()} minDate={minDate} maxDate={maxDate} showMonthDropdown showYearDropdown dropdownMode="select" yearDropdownItemNumber={3} />
                                </div>
                            </div>

                            <div className="row m-2 pb-3 pt-2">
                                <div className="col-6">
                                    <h6 className="fw-bold" style={{ fontSize: "13px", textAlign: "center", }}>Who 2 :</h6>
                                    <textarea rows="2" maxLength={150} placeholder="Description..." id="whoactions2" name="whoactions2" className="form-control px-1"
                                        style={{ borderRadius: "10px", }} value={whoActions.who2} onChange={(e) => setWhoActions({ ...whoActions, who2: e.target.value })} />
                                </div>
                                <div className="col-6">
                                    <h6 className="fw-bold" style={{ fontSize: "13px", textAlign: "center", }}>How 2 :</h6>
                                    <textarea rows="2" maxLength={150} placeholder="Description..." id="howactions2" name="howactions2" className="form-control px-1"
                                        style={{ borderRadius: "10px", }} value={howActions.how2} onChange={(e) => setHowActions({ ...howActions, how2: e.target.value })} />
                                </div>
                            </div>

                            <div className="me-3" style={{ display: "flex", justifyContent: "flex-end", gap: "8px", minHeight: "24px", }}>
                                {whatactionscount <= 2 && <>
                                    <Icon sx={{ color: green[500], cursor: "pointer" }} title="Add Action 3" onClick={() => setWhatActionsCount(3)}>
                                        add_circle
                                    </Icon>
                                    <Icon sx={{ color: red[500], cursor: "pointer" }} title="Delete Action 2" onClick={deleteWhatActions2}>
                                        delete
                                    </Icon>
                                </>}
                            </div>

                        </div>
                    </>}

                    {/* actions 3 */}
                    {whatactionscount > 2 && <>
                        <div className="pt-3 mb-2 pb-2" style={{ background: "linear-gradient(to bottom, #f0fbff 0%, powderblue 100%)", width: "100%", height: "auto", borderRadius: "10px" }}>
                            <b style={{ color: "green", display: "block", textAlign: "start", fontSize: "15px", }}>Action - III</b>
                            <div className="row m-2" style={{ alignItems: "center" }}>
                                <div className="col-9">
                                    <h6 className="fw-bold" style={{ fontSize: "13px", textAlign: "center", }}>What 3 :</h6>
                                    <textarea rows="2" maxLength={150} placeholder="Description..." id="whatactions3" name="whatactions3" className="form-control px-1"
                                        style={{ borderRadius: "10px", }} value={whatActions.what3} onChange={(e) => setWhatActions({ ...whatActions, what3: e.target.value })} />
                                </div>
                                <div className="col-3" style={{ alignContent: "center" }}>
                                    <h6 className="fw-bold" style={{ fontSize: "13px", textAlign: "center", }}>When 3 :</h6>
                                    <DatePicker placeholderText=" Pick a Date" dateFormat="dd/MM/yyyy" className="form-control px-1 py-0 rounded-0 dual-border-datepicker"
                                        selected={whenActions.when3} onChange={(date) => setWhenActions({ ...whenActions, when3: date })} onKeyDown={(e) => e.preventDefault()} minDate={minDate} maxDate={maxDate} showMonthDropdown showYearDropdown dropdownMode="select" yearDropdownItemNumber={3} />
                                </div>
                            </div>

                            <div className="row m-2 pb-3 pt-2">
                                <div className="col-6">
                                    <h6 className="fw-bold" style={{ fontSize: "13px", textAlign: "center", }}>Who 3 :</h6>
                                    <textarea rows="2" maxLength={150} placeholder="Description..." id="whoactions3" name="whoactions3" className="form-control px-1"
                                        style={{ borderRadius: "10px", }} value={whoActions.who3} onChange={(e) => setWhoActions({ ...whoActions, who3: e.target.value })} />
                                </div>
                                <div className="col-6">
                                    <h6 className="fw-bold" style={{ fontSize: "13px", textAlign: "center", }}>How 3 :</h6>
                                    <textarea rows="2" maxLength={150} placeholder="Description..." id="howactions3" name="howactions3" className="form-control px-1"
                                        style={{ borderRadius: "10px", }} value={howActions.how3} onChange={(e) => setHowActions({ ...howActions, how3: e.target.value })} />
                                </div>
                            </div>

                            <div className="me-3" style={{ textAlign: "end", }}>
                                {whatactionscount <= 3 &&
                                    <Icon sx={{ color: red[500], cursor: "pointer" }} title="Delete Action 3" onClick={deleteWhatActions3}>
                                        delete
                                    </Icon>
                                }
                            </div>

                        </div>
                    </>}
                </div>

            </div>

            {/* BORDER */}

            <div className="my-2" style={{ width: "100%", overflow: "hidden", whiteSpace: "nowrap", lineHeight: 1, fontSize: "14px", color: "lightgray" }} >
                {"+ - ".repeat(1000)}
            </div>

            {/* BEFORE, AFTER IMAGE */}

            <div className="container">
                <div className="row">
                    <div className="col-2"></div>

                    <div className="col-4">
                        <b style={{ fontSize: "15px", color: "papayawhip" }}>Before <br></br>(Include pictures/ <br></br>diagrams, etc..,)</b>
                        <div className="pt-3 mb-2 pb-2 px-5" style={{ background: "linear-gradient(to bottom, #f0fbff 0%, powderblue 100%)", width: "100%", height: "230px", borderRadius: "10px" }}>
                            {beforeImage ? <img src={beforeImagePreview} alt="Before Image" style={{ width: "100%", objectFit: "fill", height: "180px", cursor: "pointer" }} onClick={handleOpenBeforeImageInput} /> : <img src={beforeImagePreview} alt="Before Image" style={{ width: "50px", objectFit: "contain", height: "150px", cursor: "pointer" }} onClick={handleOpenBeforeImageInput} />}
                            <input ref={beforeImageRef} hidden type="file" className="form-control mt-3" id="beforeimage" name="beforeimage" accept=".jpg,.jpeg,.png,.jfif" onChange={handleBeforeFileChange} />
                            <p className="text-success fw-bold pt-2" style={{ fontSize: "13px" }}>maxmimum 5 MB allowed (1 image)</p>
                            {beforeImageError && (<p className="text-danger fw-bold" style={{ fontSize: "13px" }}>{beforeImageError}</p>)}
                        </div>

                        <div>
                            <h6 className="fw-bold" style={{ fontSize: "15px", textAlign: "start", color: "papayawhip" }}> Description :</h6>
                            <textarea type="text" rows="3" maxLength={190} placeholder="Description of the Before Image..." id="beforeimagedescription" name="beforeimagedescription" className="form-control px-1"
                                style={{ borderRadius: "10px", }} value={imagesDescription.BeforeImageDescription} onChange={(e) => setImagesDescription({ ...imagesDescription, BeforeImageDescription: e.target.value })} />
                        </div>

                    </div>
                    <div className="col-4">
                        <b style={{ fontSize: "15px", color: "papayawhip" }}>After <br></br>(Include pictures/ <br></br>diagrams, etc..,)</b>
                        <div className="pt-3 mb-2 pb-2 px-5" style={{ background: "linear-gradient(to bottom, #f0fbff 0%, powderblue 100%)", width: "100%", height: "230px", borderRadius: "10px" }}>
                            {afterImage ? <img src={afterImagePreview} alt="After Image" style={{ width: "100%", objectFit: "fill", height: "180px", cursor: "pointer" }} onClick={handleOpenAfterImageInput} /> : <img src={afterImagePreview} alt="After Image" style={{ width: "50px", objectFit: "contain", height: "150px", cursor: "pointer" }} onClick={handleOpenAfterImageInput} />}
                            <input ref={afterImageRef} hidden type="file" className="form-control mt-3" id="afterimage" name="afterimage" accept=".jpg,.jpeg,.png,.jfif" onChange={handleAfterFileChange} />
                            <p className="text-success fw-bold pt-2" style={{ fontSize: "13px" }}>maxmimum 5 MB allowed (1 image)</p>
                            {afterImageError && (<p className="text-danger fw-bold" style={{ fontSize: "13px" }}>{afterImageError}</p>)}
                        </div>

                        <div>
                            <h6 className="fw-bold" style={{ fontSize: "15px", textAlign: "start", color: "papayawhip" }}> Description :</h6>
                            <textarea type="text" rows="3" maxLength={190} placeholder="Description of the After Image..." id="afterimagedescription" name="afterimagedescription" className="form-control px-1"
                                style={{ borderRadius: "10px", }} value={imagesDescription.AfterImageDescription} onChange={(e) => setImagesDescription({ ...imagesDescription, AfterImageDescription: e.target.value })} />
                        </div>

                    </div>

                    <div className="col-2"></div>
                </div>
            </div>

            {/* BORDER */}

            <div className="my-2" style={{ width: "100%", overflow: "hidden", whiteSpace: "nowrap", lineHeight: 1, fontSize: "14px", color: "lightgray" }} >
                {"+ - ".repeat(1000)}
            </div>

            {/* STANDARDISATION, DOCUMENT NUMBERS & REVISION DETAILS */}

            <div className="container">
                <div className="row">

                    {/* Standardisation */}
                    <b style={{ fontSize: "15px", color: "papayawhip" }}>Standardisation</b>
                    <div className="mb-3" style={{ background: "linear-gradient(to bottom, #f0fbff 0%, powderblue 100%)", width: "100%", height: "auto", borderRadius: "10px", fontStyle: "italic" }}>
                        <div className="row">
                            <div className="col-12">
                                <div style={{ display: "flex", justifyContent: "space-evenly", alignItems: "center" }} className="ps-3" >
                                    <input type="checkbox" id="controlplan" name="controlplan" value="Control Plan" style={{ transform: "scale(1.5)", cursor: "pointer" }} onChange={(e) => { handleStandardisationCheckboxChange(e); setDocumentNumbersRevisionDetails((prev) => ({ ...prev, controlplan: "" })) }} />
                                    <label htmlFor="controlplan" className="custom-checkbox" style={{ cursor: "pointer" }}> Control Plan </label>

                                    <input type="checkbox" id="wis" name="wis" value="WIS" style={{ transform: "scale(1.5)", cursor: "pointer" }} onChange={(e) => { handleStandardisationCheckboxChange(e); setDocumentNumbersRevisionDetails((prev) => ({ ...prev, wis: "" })) }} />
                                    <label htmlFor="wis" className="custom-checkbox" style={{ cursor: "pointer" }}> WIS </label>

                                    <input type="checkbox" id="pfmea" name="pfmea" value="PFMEA" style={{ transform: "scale(1.5)", cursor: "pointer" }} onChange={(e) => { handleStandardisationCheckboxChange(e); setDocumentNumbersRevisionDetails((prev) => ({ ...prev, pfmea: "" })) }} />
                                    <label htmlFor="pfmea" className="custom-checkbox" style={{ cursor: "pointer" }}> PFMEA </label>

                                    <input type="checkbox" id="pmchecklist" name="pmchecklist" value="PM Check list" style={{ transform: "scale(1.5)", cursor: "pointer" }} onChange={(e) => { handleStandardisationCheckboxChange(e); setDocumentNumbersRevisionDetails((prev) => ({ ...prev, pmchecklist: "" })) }} />
                                    <label htmlFor="pmchecklist" className="custom-checkbox" style={{ cursor: "pointer" }}> PM Check list </label>

                                    <input type="checkbox" id="checksheet" name="checksheet" value="Check sheet" style={{ transform: "scale(1.5)", cursor: "pointer" }} onChange={(e) => { handleStandardisationCheckboxChange(e); setDocumentNumbersRevisionDetails((prev) => ({ ...prev, checksheet: "" })) }} />
                                    <label htmlFor="checksheet" className="custom-checkbox" style={{ cursor: "pointer" }}> Check sheet </label>

                                    <input type="checkbox" id="procedure" name="procedure" value="Procedure" style={{ transform: "scale(1.5)", cursor: "pointer" }} onChange={(e) => { handleStandardisationCheckboxChange(e); setDocumentNumbersRevisionDetails((prev) => ({ ...prev, procedure: "" })) }} />
                                    <label htmlFor="procedure" className="custom-checkbox" style={{ cursor: "pointer" }}> Procedure </label>

                                    <input type="checkbox" id="designchange" name="designchange" value="Design change" style={{ transform: "scale(1.5)", cursor: "pointer" }} onChange={(e) => { handleStandardisationCheckboxChange(e); setDocumentNumbersRevisionDetails((prev) => ({ ...prev, designchange: "" })) }} />
                                    <label htmlFor="designchange" className="custom-checkbox" style={{ cursor: "pointer" }}> Design change </label>

                                    <input type="checkbox" id="others" name="others" value="Others" style={{ transform: "scale(1.5)", cursor: "pointer" }} onChange={(e) => { handleStandardisationCheckboxChange(e); setDocumentNumbersRevisionDetails((prev) => ({ ...prev, others: "" })) }} />
                                    <label htmlFor="others" className="custom-checkbox" style={{ cursor: "pointer" }}> Others </label>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Document Numbers & Revision Details */}
                    <b style={{ fontSize: "15px", color: "papayawhip" }}>Document Numbers & Revision Details</b>
                    <div className="row">
                        <div className="col-2"></div>
                        <div className="col-8">
                            <div className="px-4 py-2 mb-2" style={{ background: "linear-gradient(to bottom, #f0fbff 0%, powderblue 100%)", width: "100%", height: "auto", borderRadius: "30px", }}>
                                {standardisation.controlplan && <div className="mt-2">
                                    <h6 className="fw-bold" style={{ fontSize: "13px", textAlign: "start", }}>Control Plan :</h6>
                                    <textarea type="text" rows="2" maxLength={190} placeholder="Control Plan..." id="controlplantext" name="controlplantext" className="form-control px-1"
                                        style={{ borderRadius: "10px", }} value={documentNumbersRevisionDetails.controlplan} onChange={(e) => setDocumentNumbersRevisionDetails((prev) => ({ ...prev, controlplan: e.target.value }))} />
                                </div>}
                                {standardisation.wis && <div className="mt-3">
                                    <h6 className="fw-bold" style={{ fontSize: "13px", textAlign: "start", }}>WIS :</h6>
                                    <textarea type="text" rows="2" maxLength={190} placeholder="WIS..." id="wistext" name="wistext" className="form-control px-1"
                                        style={{ borderRadius: "10px", }} value={documentNumbersRevisionDetails.wis} onChange={(e) => setDocumentNumbersRevisionDetails((prev) => ({ ...prev, wis: e.target.value }))} />
                                </div>}
                                {standardisation.pfmea && <div className="mt-3">
                                    <h6 className="fw-bold" style={{ fontSize: "13px", textAlign: "start", }}>PFMEA :</h6>
                                    <textarea type="text" rows="2" maxLength={190} placeholder="PFMEA..." id="pfmeatext" name="pfmeatext" className="form-control px-1"
                                        style={{ borderRadius: "10px", }} value={documentNumbersRevisionDetails.pfmea} onChange={(e) => setDocumentNumbersRevisionDetails((prev) => ({ ...prev, pfmea: e.target.value }))} />
                                </div>}
                                {standardisation.pmchecklist && <div className="mt-3">
                                    <h6 className="fw-bold" style={{ fontSize: "13px", textAlign: "start", }}>PM Check List :</h6>
                                    <textarea type="text" rows="2" maxLength={190} placeholder="PM Check List..." id="pmchecklisttext" name="pmchecklisttext" className="form-control px-1"
                                        style={{ borderRadius: "10px", }} value={documentNumbersRevisionDetails.pmchecklist} onChange={(e) => setDocumentNumbersRevisionDetails((prev) => ({ ...prev, pmchecklist: e.target.value }))} />
                                </div>}
                                {standardisation.checksheet && <div className="mt-3">
                                    <h6 className="fw-bold" style={{ fontSize: "13px", textAlign: "start", }}>Check Sheet :</h6>
                                    <textarea type="text" rows="2" maxLength={190} placeholder="Check Sheet..." id="checksheettext" name="checksheettext" className="form-control px-1"
                                        style={{ borderRadius: "10px", }} value={documentNumbersRevisionDetails.checksheet} onChange={(e) => setDocumentNumbersRevisionDetails((prev) => ({ ...prev, checksheet: e.target.value }))} />
                                </div>}
                                {standardisation.procedure && <div className="mt-3">
                                    <h6 className="fw-bold" style={{ fontSize: "13px", textAlign: "start", }}>Procedure :</h6>
                                    <textarea type="text" rows="2" maxLength={190} placeholder="Procedure..." id="proceduretext" name="proceduretext" className="form-control px-1"
                                        style={{ borderRadius: "10px", }} value={documentNumbersRevisionDetails.procedure} onChange={(e) => setDocumentNumbersRevisionDetails((prev) => ({ ...prev, procedure: e.target.value }))} />
                                </div>}
                                {standardisation.designchange && <div className="mt-3">
                                    <h6 className="fw-bold" style={{ fontSize: "13px", textAlign: "start", }}>Design Change :</h6>
                                    <textarea type="text" rows="2" maxLength={190} placeholder="Design Change..." id="designchangetext" name="designchangetext" className="form-control px-1"
                                        style={{ borderRadius: "10px", }} value={documentNumbersRevisionDetails.designchange} onChange={(e) => setDocumentNumbersRevisionDetails((prev) => ({ ...prev, designchange: e.target.value }))} />
                                </div>}
                                {standardisation.others && <div className="mt-3">
                                    <h6 className="fw-bold" style={{ fontSize: "13px", textAlign: "start", }}>Others :</h6>
                                    <textarea type="text" rows="2" maxLength={190} placeholder="Others..." id="otherstext" name="otherstext" className="form-control px-1"
                                        style={{ borderRadius: "10px", }} value={documentNumbersRevisionDetails.others} onChange={(e) => setDocumentNumbersRevisionDetails((prev) => ({ ...prev, others: e.target.value }))} />
                                </div>}
                            </div>

                        </div>
                        <div className="col-2"></div>

                    </div>

                </div>
            </div>

            {/* BORDER */}

            <div className="my-2" style={{ width: "100%", overflow: "hidden", whiteSpace: "nowrap", lineHeight: 1, fontSize: "14px", color: "lightgray" }} >
                {"+ - ".repeat(1000)}
            </div>

            {/* BENEFITS */}

            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <b style={{ fontSize: "15px", color: "papayawhip" }}>Benefits (P, Q, C, D, S, M)</b>
                        <div className="pt-3 px-4 mb-2 pb-2" style={{ background: "linear-gradient(to bottom, #f0fbff 0%, powderblue 100%)", width: "100%", height: "auto", borderRadius: "10px" }}>
                            {improvementCategory.productivity && <div className="mt-2">
                                <h6 className="fw-bold" style={{ fontSize: "13px", textAlign: "start", }}>Productivity :</h6>
                                <textarea type="text" rows="2" maxLength={190} placeholder="Productivity..." id="productivitytext" name="productivitytext" className="form-control px-1"
                                    style={{ borderRadius: "10px", }} value={benefits.productivity} onChange={(e) => setBenefits((prev) => ({ ...prev, productivity: e.target.value }))} />
                            </div>}
                            {improvementCategory.quality && <div className="mt-3">
                                <h6 className="fw-bold" style={{ fontSize: "13px", textAlign: "start", }}>Quality :</h6>
                                <textarea type="text" rows="2" maxLength={190} placeholder="Quality..." id="qualitytext" name="qualitytext" className="form-control px-1"
                                    style={{ borderRadius: "10px", }} value={benefits.quality} onChange={(e) => setBenefits((prev) => ({ ...prev, quality: e.target.value }))} />
                            </div>}
                            {improvementCategory.cost && <div className="mt-3">
                                <h6 className="fw-bold" style={{ fontSize: "13px", textAlign: "start", }}>Cost :</h6>
                                <textarea type="text" rows="2" maxLength={190} placeholder="Cost..." id="costtext" name="costtext" className="form-control px-1"
                                    style={{ borderRadius: "10px", }} value={benefits.cost} onChange={(e) => setBenefits((prev) => ({ ...prev, cost: e.target.value }))} />
                            </div>}
                            {improvementCategory.delivery && <div className="mt-3">
                                <h6 className="fw-bold" style={{ fontSize: "13px", textAlign: "start", }}>Delivery :</h6>
                                <textarea type="text" rows="2" maxLength={190} placeholder="Delivery..." id="deliverytext" name="deliverytext" className="form-control px-1"
                                    style={{ borderRadius: "10px", }} value={benefits.delivery} onChange={(e) => setBenefits((prev) => ({ ...prev, delivery: e.target.value }))} />
                            </div>}
                            {improvementCategory.safety && <div className="mt-3">
                                <h6 className="fw-bold" style={{ fontSize: "13px", textAlign: "start", }}>Safety :</h6>
                                <textarea type="text" rows="2" maxLength={190} placeholder="Safety..." id="safetytext" name="safetytext" className="form-control px-1"
                                    style={{ borderRadius: "10px", }} value={benefits.safety} onChange={(e) => setBenefits((prev) => ({ ...prev, safety: e.target.value }))} />
                            </div>}
                            {improvementCategory.morale && <div className="mt-3">
                                <h6 className="fw-bold" style={{ fontSize: "13px", textAlign: "start", }}>Morale :</h6>
                                <textarea type="text" rows="2" maxLength={190} placeholder="Morale..." id="moraletext" name="moraletext" className="form-control px-1"
                                    style={{ borderRadius: "10px", }} value={benefits.morale} onChange={(e) => setBenefits((prev) => ({ ...prev, morale: e.target.value }))} />
                            </div>}
                        </div>
                    </div>
                </div>
            </div>

            {/* BORDER */}

            <div className="my-2" style={{ width: "100%", overflow: "hidden", whiteSpace: "nowrap", lineHeight: 1, fontSize: "14px", color: "lightgray" }} >
                {"+ - ".repeat(1000)}
            </div>

            {/* SUPPORTING TEAM MEMBERS & DEPARTMENTS */}

            <div className="container">
                <div className="row">
                    <div className="col-3"></div>
                    <div className="col-6">
                        <b style={{ fontSize: "15px", color: "papayawhip" }}>Supporting Team Members & Departments</b>
                        <div className="pt-3 px-4 mb-2 pb-2" style={{ background: "linear-gradient(to bottom, #f0fbff 0%, powderblue 100%)", width: "100%", height: "auto", borderRadius: "30px" }}>
                            <textarea type="text" rows="4" maxLength={190} placeholder="Supporting Team Members & Department..." id="supportingteammembersdepartment" name="supportingteammembersdepartment" className="form-control px-1"
                                style={{ borderRadius: "10px", }} value={supportingTeamMembers} onChange={(e) => setSupportingTeamMembers(e.target.value)} />
                        </div>
                    </div>
                    <div className="col-3"></div>
                </div>
            </div>

            {/* BORDER */}

            <div className="my-2" style={{ width: "100%", overflow: "hidden", whiteSpace: "nowrap", lineHeight: 1, fontSize: "14px", color: "lightgray" }} >
                {"+ - ".repeat(1000)}
            </div>

            {/* BUTTONS */}

            {missingFields.length > 0 ? null : <> <b className="btn btn-success m-2 fw-bold" onClick={SubmitRequest}>SUBMIT</b>
                <b className="btn btn-primary m-2 fw-bold" onClick={ResetPage}>RESET</b></>}





            {/* ERROR MODAL */}

            <Modal
                show={showModal}
                onHide={handleCloseModal}
                backdrop="static"
                keyboard={false}
                style={{ backgroundColor: "rgba(49, 48, 48, 0.7)" }}
            >
                <Modal.Header>
                    <h6 style={{ color: "red", fontWeight: "bold", display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
                        {errorMessage}
                        <p
                            className="btn btn-close ms-auto"
                            onClick={handleCloseModal}
                        >
                        </p>
                    </h6>
                </Modal.Header>
            </Modal>

        </div>
    )
}

export default Create;